import * as types from "../actions/ActionTypes.js";

export const getInitialState = () => (
    {
        organization: null,
        settings: null,
        isSsoEnabled: false,
        isSettingsValid: true
    });

const organizationReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_ORGANIZATION_SETTINGS_BY_TICKET_SUCCEEDED:
        return Object.assign({}, state, { settings: action.settings });
    case types.GET_ORGANIZATION_BY_ID_SUCCEEDED:
        return Object.assign({}, state, { organization: action.organization });
    case types.GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_SUCCEEDED: {
        const settings = action.settings;
        return Object.assign({}, state, { isSsoEnabled: settings.isSsoEnabled });
    }
    case types.GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_FAILED:
        return Object.assign({}, state, { isSsoEnabled: false });
    default:
        return state;
    }
};


export default organizationReducer;
